import type {
  Org_Coursera_Program_SkillSetAvailabilityType as LegacySkillSetAvailabilityType,
  EnterpriseProgram_SkillsetAvailabilityType as SkillsetAvailabilityType,
} from '__generated__/graphql-types';

import type { EnterpriseProgramFromSlugFragment } from 'bundles/enterprise-legacy-learner-home/queries/__generated__/EnterpriseProgramBySlugQuery';
import type { EnterpriseProgramsV1 } from 'bundles/naptimejs/resources/__generated__/EnterpriseProgramsV1';

/**
 * This is file is used to convert EnterpriseProgramFromSlugFragment to EnterpriseProgramsV1 for compatibility in skills bundle but should be removed when the Skills team migrates to new graphQL entity.
 */

const mapSkillsetAvailabilityType = (
  newType: SkillsetAvailabilityType | null | undefined
): LegacySkillSetAvailabilityType | undefined => {
  switch (newType) {
    case 'SKILL_SET_AVAILABILITY_TYPE_ALL_SKILLSETS':
      return 'ALL_SKILLSETS';
    case 'SKILL_SET_AVAILABILITY_TYPE_LINKED_SKILLSETS_ONLY':
      return 'LINKED_SKILLSETS_ONLY';
    case 'SKILL_SET_AVAILABILITY_TYPE_INVALID':
    case null:
    case undefined:
      return undefined;
    default:
      return undefined;
  }
};

export const convertEnterpriseProgramFragment = (program: EnterpriseProgramFromSlugFragment): EnterpriseProgramsV1 => {
  return {
    id: program.id,
    metadata: {
      name: program.name,
      slug: program.slug,
      endedAt: Number(program.endedAt),
      launchedAt: Number(program.launchedAt),
      squareLogo: program.squareLogo,
      rectangularLogo: program.rectangularLogo,
      tagline: program.tagline,
      curriculumId: program.naptimeCurriculum?.id || '',
      linkedTargetSkillProfileIds: program.naptimeLinkedTargetSkillProfiles?.map((profile) => profile.id) || [],
      linkedAcademicDisciplineIds: program.linkedAcademicDisciplineIds || [],
      tutorialVideoUrl: program.tutorialVideoUrl,
      tutorialVideoAssetId: program.tutorialVideoAssetId,
      primaryColor: program.primaryColor,
      landingPageBanner: program.landingPageBanner,
      isLocked: false,
      skillSetAvailabilityType: mapSkillsetAvailabilityType(program.skillsetAvailabilityType) || 'ALL_SKILLSETS',
    },
    thirdPartyOrganizationId: program.naptimeThirdPartyOrganization?.id,
  };
};
